import { useParams } from "react-router-dom"
import { AdminDocuments } from "components/AdminDocuments"
import { useAuthenticated } from "providers/A12n"
import { useI18n } from "providers/I18n"

function Documents() {
  const { t } = useI18n()
  const { id } = useParams<{ id: string }>()

  const { hasAuthority } = useAuthenticated()
  const documentTypes = [
    {
      label: t("suppliergroups.documents.logo"),
      value: t("suppliergroups.documents.logo"),
    },
    {
      label: t("suppliergroups.documents.other"),
      value: t("suppliergroups.documents.other"),
    },
  ]

  return (
    <AdminDocuments
      documentTypes={documentTypes}
      type="suppliergroups"
      ownerEntityId={id}
      disabled={!hasAuthority(["AUTH_MANAGE_DOCUMENT_SUPPLIER_GROUP"])}
    />
  )
}

export default Documents
